<style scoped lang="scss" type="text/scss">
    .type-selector-panel {
        display: flex;
        flex-wrap: nowrap;
        overflow: auto;

        .type-item {
            margin-bottom: 0;
            margin-right: .25rem;
            width: 4.75rem;
            min-width: 4.75rem;

            &:last-of-type {
                margin-right: 0;
            }
        }
    }
</style>

<template>
    <div class="type-selector-panel">
        <square-info-block class="type-item" v-for="(item, index) in items" :key="index" :icon="item.icon"
                           :with-angle="false" :active="routeName === item.route_name"
                           @click.native="redirect(item.route_name)">
            {{ item.title }}
        </square-info-block>
    </div>
</template>

<script>
    import SquareInfoBlock from '../../../../../components/square-info-block/index';
    import ROUTE_NAMES from '../../../../../router/names';

    export default {
        name: '',
        components: {
            SquareInfoBlock
        },
        data () {
            return {
                items: [
                    {
                        title: '填报概览',
                        icon: '&#xe618;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_OVERVIEW
                    },
                    {
                        title: '联系人',
                        icon: '&#xe696;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_CONTACT
                    },
                    {
                        title: '预报名',
                        icon: '&#xe657;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_FORECAST_ATTENDANCE
                    },
                    {
                        title: '证书名单',
                        icon: '&#xe657;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_CERTIFICATE
                    },
                    {
                        title: '推荐解说',
                        icon: '&#xe690;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_NARRATE
                    },
                    {
                        title: '推荐裁判',
                        icon: '&#xe61f;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_REFEREE
                    },
                    {
                        title: '宣传员',
                        icon: '&#xe61f;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_PROPAGANDISTS
                    },
                    {
                        title: '淘宝',
                        icon: '&#xe61f;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_TAOBAO
                    },
                    {
                        title: '推荐旗手',
                        icon: '&#xe604;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_FLAG_BEARER
                    },
                    {
                        title: '参赛介绍',
                        icon: '&#xe791;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_INTRODUCE
                    },
                    {
                        title: '总经费',
                        icon: '&#xe615;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_FUNDING
                    },
                    {
                        title: '赞助',
                        icon: '&#xe96b;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_SPONSORSHIP
                    },
                    {
                        title: '机器人',
                        icon: '&#xe612;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_ROBOT
                    },
                    {
                        title: '收件信息',
                        icon: '&#xe617;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_CONSIGNEE
                    },
                    {
                        title: '到场情况',
                        icon: '&#xe61a;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_PRESENT
                    },
                    {
                        title: '住宿信息',
                        icon: '&#xe67c;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_ACCOMMODATION
                    },
                    {
                        title: '合照',
                        icon: '&#xe619;',
                        route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_GROUP_PHOTO
                    }
                ]
            };
        },
        computed: {
            routeName () {
                return this.$route.name;
            }
        },
        methods: {
            redirect (routeName) {
                this.$router.push({
                    name: routeName
                });
            }
        }
    };
</script>
